module.exports = __webpack_public_path__ + "static/media/icon-x-disable.8484f1ff.svg";